import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import Loader from "../../../../components/Loader/Loader";
import {useFetch} from "../../../../components/common/FetchProvider";
import {numberToWords} from "../../../../utils/numberToWords";
import {getMonthName, getMonthNameInPortguese, getCurrencyNameByCode, formatNumberToInternational} from "../../../../utils/utils";
import ErrorModal from "./ErrorModal";
import './report.css';
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const COUNTRY = process.env.REACT_APP_COUNTRY;


const PdfReport = () => {
    const [loading, setLoading] = useState(false);
    const fetchWrapper = useFetch();
    const [apiData, setApiData] = useState({});
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [deliveryTerm, setDeliveryTerm] = useState(false); // Flag to toggle content


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const recitaId = queryParams.get("id");
    const currency = queryParams.get("currency");

    useEffect(() => {
        getExpenseById(recitaId, currency);
    }, []);

    const getExpenseById = async (recitaId, currency) => {

        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/financial-management/despesa/${recitaId}`;
            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    setApiData(responseData.data);
                    if (responseData.data.deliveryTerm === "yes")
                        setDeliveryTerm(true);
                }
            } else {
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    }


    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="p-1">
            <Loader show={loading}/>
            {showErrorModal &&
                <ErrorModal
                    showErrorModal={showErrorModal}
                    setShowErrorModal={setShowErrorModal}
                    errorMessage={errorMessage}
                />
            }


            {/* Container for content */}
            <div className="relative text-black print:text-black">
                {/* Print Button */}
                <div className="absolute top-1 right-2 print:hidden">
                    <button
                        onClick={handlePrint}
                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
                        Print
                    </button>
                </div>

                {/* Content starts */}
                <div className="flex flex-col items-center pt-4 print:pt-6">


                    <div className="flex flex-col items-center pt-2 print:pt-3">
                        {/* Header Section */}
                        <div className="text-center mb-0">
                            <div className="flex items-center justify-center h-[100px]">
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className="w-[60px] h-[80px] object-contain"
                                />
                            </div>
                            <h1 className="text-xl font-bold uppercase">República de Angola</h1>
                            <h2 className="text-lg">Ministério das Relações Exteriores</h2>
                            <h2 className="text-lg">Embaixada da República de Angola no {COUNTRY}</h2>
                        </div>

                        {/* Document Title */}
                        <h2 className="text-lg font-bold mb-6">
                            REQUISIÇÃO DE VERBA
                            Nº {apiData.seqNumber} / {apiData.registrationDate && apiData.registrationDate.substring(0, 4)}
                        </h2>

                        {/* "Parecer" and "Despacho" Sections */}
                        <div
                            className="w-full max-w-3xl flex mb-6"
                            style={{borderBottom: "1px solid black"}} // Explicit dark horizontal line
                        >
                            <div
                                className="w-1/2 text-center p-4"
                                style={{borderRight: "1px solid black"}} // Explicit dark vertical line
                            >
                                <h3 className="font-bold mb-20">Parecer</h3>
                            </div>
                            <div className="w-1/2 text-center p-4">
                                <h3 className="font-bold">Despacho</h3>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="w-full max-w-3xl mb-8">
                            <p className="text-md mb-4">
                                A Sua Excelência senhor(a) Embaixadora,
                            </p>
                            <p className="text-md leading-relaxed mb-4">
                                Por intermédio desta, o sector de finanças solicita a autorização para o pagamento da
                                seguinte despesa:
                            </p>

                            {/* First Form Section */}
                            <div className="border" style={{border: "1px solid black"}}>
                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/4 p- font-bold" style={{borderRight: "1px solid black"}}>{apiData.currency}
                                    </div>
                                    <div className="w-3/4 p-1">{formatNumberToInternational(apiData.amount)}</div>
                                </div>
                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/4 p-1 font-bold"
                                         style={{borderRight: "1px solid black"}}>Beneficiário
                                    </div>
                                    <div className="w-3/4 p-1">{apiData.beneficiaryName}</div>
                                </div>
                                <div className="flex">
                                    <div className="w-1/4 p-1 font-bold"
                                         style={{borderRight: "1px solid black"}}>Descrição
                                    </div>
                                    <div className="w-3/4 p-1">
                                        {apiData.description}
                                    </div>
                                </div>
                            </div>

                            {/* Second Form Section */}
                            <div className="border mt-2" style={{border: "1px solid black"}}>
                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/3 p-1 font-bold"
                                         style={{borderRight: "1px solid black"}}>Órgão
                                    </div>
                                    <div className="w-2/3 p-1">{apiData.organizationName}</div>
                                </div>
                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/3 p-1 font-bold" style={{borderRight: "1px solid black"}}>Fonte
                                        de Recurso
                                    </div>
                                    <div className="w-2/3 p-1">{apiData.fundResource}</div>
                                </div>
                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/3 p-1 font-bold" style={{borderRight: "1px solid black"}}>Nat.
                                        de Despesa
                                    </div>
                                    <div className="w-2/3 p-1">{apiData.nature}</div>
                                </div>

                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/3 p-1 font-bold"
                                         style={{borderRight: "1px solid black"}}>Câmbio
                                    </div>
                                    <div className="w-2/3 p-1">{formatNumberToInternational(apiData.exchangeRate)}</div>
                                </div>
                                <div className="flex" style={{borderBottom: "1px solid black"}}>
                                    <div className="w-1/3 p-1 font-bold"
                                         style={{borderRight: "1px solid black"}}>Equivalente-{apiData.currency === 'EUR' ? 'EUR' : 'USD'}
                                    </div>
                                    <div
                                        className="w-2/3 p-1">{formatNumberToInternational(apiData.amountUsdValue)}</div>
                                </div>

                            </div>
                        </div>

                        {/* Footer Section */}
                        <div className="w-full max-w-3xl text-left">
                            <p className="text-md">
                                Tóquio, {apiData.registrationDate && apiData.registrationDate.substring(8, 10)} de {apiData.registrationDate && getMonthNameInPortguese(apiData.registrationDate.substring(5, 7))} de {apiData.registrationDate && apiData.registrationDate.substring(0, 4)}
                            </p>
                        </div>
                    </div>
                </div>
                {deliveryTerm && (
                    <>
                        <div className="print-page-break"></div>

                        <div className="flex flex-col items-center pt-4 print:pt-6 mt-20">
                            {/* Header Section */}
                            <div className="text-center mb-2">
                                <div className="flex items-center justify-center h-[100px]">
                                    <img
                                        src={logo}
                                        alt="Logo"
                                        className="w-[60px] h-[80px] object-contain"
                                    />
                                </div>
                                <h1 className="text-xl font-bold">REPÚBLICA DE ANGOLA</h1>
                                <h2 className="text-xl">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
                                <h2 className="text-xl">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
                            </div>

                            {/* Currency Information Section */}
                            <h2 className="text-xl font-bold mb-8">TERMO DE ENTREGA</h2>


                            {/* Main Body Section */}
                            <div className="w-full max-w-3xl mb-8">
                                <p className="text-md leading-relaxed">
                                    Por intermédio desta, se faz constar que foi entregue o valor em
                                    <strong> {apiData.currency} {formatNumberToInternational(apiData.amount)} ({numberToWords(apiData.amount, apiData.currency)})</strong> com
                                    o seguinte objectivo;
                                </p>
                                <p className="text-md leading-relaxed">
                                    {apiData.description}
                                </p>
                                <p className="text-md mt-4 font-bold leading-relaxed">
                                    SECTOR DE FINANÇAS DA(O) EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY},
                                    Tóquio, {apiData.registrationDate && apiData.registrationDate.substring(8, 10)} de {apiData.registrationDate && getMonthNameInPortguese(apiData.registrationDate.substring(5, 7))} de {apiData.registrationDate && apiData.registrationDate.substring(0, 4)}
                                </p>
                            </div>
                            <div>
                                {/* Any additional content you want to break to another page */}
                            </div>


                            {/* Footer Section */}
                            <div className="w-full max-w-3xl flex justify-between mt-12">
                                <div className="text-center">
                                    <p className="font-bold text-md mb-2">Entreguei</p>
                                    <p className="mt-2 text-center">O Adido Financeiro</p>
                                    <p className="font-bold">{FINANCIAL_HEAD}</p>

                                    <hr className="mt-10 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                                </div>
                                <div className="text-center">
                                    <p className="font-bold text-md mb-2">Recebi</p>
                                    <p className="mt-4"></p>
                                    <hr className="mt-10 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PdfReport;
